import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { SnowflakeConnectionDetailsGenerateCommand } from "@/components/pages/integrations/components/provider-connections/snowflake/components/drawer/details/SnowflakeConnectionGenerateCommand";

export const SnowflakeConnectionDetails: FC = () => {
  return (
    <Stack p={2} spacing={1.5}>
      <Typography fontWeight="medium">
        Connect your Snowflake account.
      </Typography>
      <Typography fontWeight="medium">
        1. Choose Generate to generate command.
      </Typography>
      <Typography fontWeight="medium">
        2. Run the command in your terminal.
        <Typography variant="body2" pt={0.5} px={2.5}>
          This will create a user role, warehouse, and storage integration.
        </Typography>
      </Typography>

      <SnowflakeConnectionDetailsGenerateCommand />
    </Stack>
  );
};
